"use client";

import React, { useEffect, useState } from "react";
import overlayStyles from "../../../../css/components/overlaymodal-animations.module.css";
import TotalOutStanding from "./TotalOutStanding.jsx";
import overlayTfStyles from "../css/overlayToFollows.module.css";
import PharmacistSignatureModal from "../../../global/view/PharmacistSignatureModal.jsx";
import Button from "../../../../components/Button";

function CompletedPopup({ isOpen, onClose }) {
  if (!isOpen) return null;
  return (
    <div className={`${overlayStyles.modalOverlay} ${overlayStyles.show}`}>
      <div className={`${overlayStyles.modalContent} ${overlayStyles.stepEnter} ${overlayTfStyles.completedModal}`}>
        <div className={overlayTfStyles.completedIcon}>✔</div>
        <h2 className={overlayTfStyles.completedTitle}>Completed</h2>
        <Button variant="primary" onClick={onClose}>Done</Button>
      </div>
    </div>
  );
}

export default function ToFollowsOverlayModal({ isOpen, onClose, triggerSignature = false, showCompleteButton = false, profileNo = null, onDispensed }) {
  const [open, setOpen] = useState(isOpen);
  const [showSignature, setShowSignature] = useState(false);
  const [showCompleted, setShowCompleted] = useState(false);

  useEffect(() => {
    setOpen(isOpen);
    if (isOpen && triggerSignature) {
      setShowSignature(true);
    }
  }, [isOpen, triggerSignature]);

  const handleClose = () => {
    setOpen(false);
    setShowSignature(false);
    setShowCompleted(false);
    onClose?.();
  };

  const handleSignatureConfirm = () => {
    setShowSignature(false);
    setShowCompleted(true);
  };

  if (!open) return null;

  return (
    <div className={`${overlayStyles.modalOverlay} ${overlayStyles.show}`}>
      <div className={`${overlayStyles.modalContent} ${overlayTfStyles.modalContainer}`}>
        <button className={overlayStyles.closeButton} onClick={handleClose} aria-label="Close overlay">×</button>
        <TotalOutStanding asModal profileNo={profileNo} onDispensed={onDispensed} />
        {showCompleteButton && (
          <div className={overlayTfStyles.completeActionBar}>
            <Button variant="primary" onClick={() => setShowSignature(true)}>Complete Follow Up</Button>
          </div>
        )}
      </div>
      <PharmacistSignatureModal
        isOpen={showSignature}
        onClose={() => setShowSignature(false)}
        onNext={handleSignatureConfirm}
        openPreviewOnNext={false}
        nextLabel="Confirm"
        title="Signature Required"
      />
      <CompletedPopup isOpen={showCompleted} onClose={handleClose} />
    </div>
  );
}
